import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34a36c23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mypage py-3" }
const _hoisted_2 = { class: "section px-3 pt-4 mt-2" }
const _hoisted_3 = { class: "bg-white border border-outline-color px-3 mt-1 round-4" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "利用規約", -1))
const _hoisted_6 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "プライバシーポリシー", -1))
const _hoisted_9 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "取扱職種の範囲等", -1))
const _hoisted_12 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "退会", -1))
const _hoisted_14 = { class: "d-flex justify-content-end align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      その他\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            href: _ctx.ruleLink,
            class: "d-flex justify-content-between align-items-center py-3"
          }, [
            _hoisted_5,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ])
          ], 8, _hoisted_4),
          _createTextVNode(),
          _createElementVNode("a", {
            href: _ctx.externalLink.PRIVACY,
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, [
            _hoisted_8,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ])
          ], 8, _hoisted_7),
          _createTextVNode(),
          _createElementVNode("a", {
            href: _ctx.externalLink.OCCUPATIONS,
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, [
            _hoisted_11,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ])
          ], 8, _hoisted_10),
          _createTextVNode(),
          _createVNode(_component_RouterLink, {
            to: { name: 'LeaveConfirmation' },
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          })
        ])
      ]),
      _createTextVNode(),
      _createVNode(_component_AppFooter),
      _createTextVNode(),
      _createVNode(_component_BlockBack)
    ])
  ]))
}